import React from 'react';
import type { MobileMenuNavItem } from 'common-ui';
import { inspectorMode } from 'common-ui';
import type { DLClickEventHandlerProps, LinkEntryType } from 'tsconfig/types';
import HandleLevel3Links from './HandleLevel3Links';
import { TypeBasedConditionalContent } from '../../../contentful/CmsConditionalContainer/TypeBasedConditionalContent';

type RenderLevel3MenuProps = {
  level3MenuContent: MobileMenuNavItem;
  level2MenuContentTitle: string;
  dlClickEventHandler: DLClickEventHandlerProps;
};

const RenderLevel3Menu = ({
  level3MenuContent,
  level2MenuContentTitle,
  dlClickEventHandler,
}: RenderLevel3MenuProps): React.JSX.Element => {
  if (!level3MenuContent) {
    return <div></div>;
  }

  const level3Links = (): React.JSX.Element[] | undefined =>
    level3MenuContent?.children?.map((linkContent: LinkEntryType) => (
      <TypeBasedConditionalContent<LinkEntryType>
        content={linkContent}
        contentTypes={['link']}
        key={linkContent?.fields?.title}
      >
        <HandleLevel3Links
          url={linkContent?.fields?.url}
          level2MenuContentTitle={level2MenuContentTitle}
          level3MenuContentTitle={level3MenuContent.title}
          linkContentTitle={linkContent?.fields?.title}
          linkContentId={linkContent?.sys?.id}
          dlClickEventHandler={dlClickEventHandler}
        />
      </TypeBasedConditionalContent>
    ));

  return (
    <div>
      {level3Links()}
      {level3MenuContent?.url && (
        <a
          href={level3MenuContent.url}
          className="navMenuSectionLink"
          onClick={() =>
            dlClickEventHandler(
              `${level2MenuContentTitle}:${level3MenuContent.title}:View all ${level3MenuContent.title}`,
            )
          }
          {...inspectorMode(level3MenuContent.id, 'title')}
        >
          View all {level3MenuContent.title}
        </a>
      )}
    </div>
  );
};

export default RenderLevel3Menu;
